<script setup lang="ts">
import { useAddress } from '../composables/address'
import { usePageContext } from "vike-vue/usePageContext";
import { useI18n } from 'vue-i18n';

const { breadcrumbs } = useAddress()
const pageContext = usePageContext();
const { t } = useI18n();

function capitalize(s: string): string {
  if (typeof s !== 'string' || s.length === 0) {
    return '';
  }
  return s.charAt(0).toUpperCase() + s.slice(1);
}
</script>
<template>
  <nav
    class="max-w-[1400px] flex flex-wrap items-center gap-2 text-sm text-gray-600 bg-gray-50 mx-auto"
    aria-label="Breadcrumb"
  >
    <div><a href="/" class="text-brand underline">{{ t('navigation.home') }}</a></div>
    <template v-for="({ path, name }, i) of breadcrumbs" :key="path">
      <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
      </svg>
      <div v-if="i == breadcrumbs.length - 1" aria-current="page">
        {{ name }}
      </div>
      <div v-else>
        <a
          v-if="path"
          class="text-brand hover:bg-brand/10 underline"
          :href="'/' + path + (pageContext.routeParams.subpath ?? '')"
        >
          {{ capitalize(name) }}
        </a>
        <span v-else>{{ name }}</span>
      </div>
    </template>
  </nav>
</template>
